// Обработка ошибок загрузки чанков при новом деплое
export const isChunkError = (error: any): boolean => {
  return (
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    (error?.message?.includes('404') && error?.message?.includes('.js'))
  );
};

export const handleChunkError = (error: any): void => {
  if (isChunkError(error)) {
    console.warn('Chunk loading error detected. Reloading page...', error);

    // Проверяем, не перезагружали ли мы уже страницу недавно
    const lastReload = sessionStorage.getItem('lastChunkErrorReload');
    const now = Date.now();

    // Если последняя перезагрузка была больше 10 секунд назад - перезагружаем
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('lastChunkErrorReload', now.toString());
      window.location.reload();
    } else {
      console.error('Too many chunk reload attempts. Please refresh manually.');
    }
  }
};

// Глобальный обработчик для unhandled promise rejections
export const setupChunkErrorHandler = (): void => {
  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkError(event.reason)) {
      event.preventDefault();
      handleChunkError(event.reason);
    }
  });
};
